import React, { useContext } from "react";
import { FormContext } from "./Form";
import { Informative } from "../../Inputs/General/Index";
import { AcreditedArea } from "./Styles";

export default function Acredited({ value, className = "" }) {
  /**
   * @type {{
   *    document:import("types/typedef/documents").DocumentI
   * }}
   */
  const { document } = useContext(FormContext);

  return (
    <>
      {className !== "" ? (
        <div>
          <Informative
            readonly={true}
            label="Acreditado"
            value={!value ? document.amount.acumulated.text : value}
          />
        </div>
      ) : (
        <AcreditedArea>
          <Informative
            readonly={true}
            label="Acreditado"
            value={!value ? document.amount.acumulated.text : value}
          />
        </AcreditedArea>
      )}
    </>
  );
}
